import type { Framework } from '@toeverything/infra';

import { GlobalDialogService } from '../dialogs';
import { UrlService } from '../url';
import { HelpActionsService } from './services/help-actions';

export { HelpActionsService } from './services/help-actions';
export { sanitizeFeedbackPrefill } from './services/help-actions';

export function configureHelpActionsModule(framework: Framework) {
  framework.service(
    HelpActionsService,
    services =>
      new HelpActionsService(
        services.get(GlobalDialogService),
        services.get(UrlService)
      )
  );
}
